
const stat = [
  {code:"Pending", colr:"warning"},
  {code:"Active", colr:"success"},
  {code:"Expired", colr:"danger"},
  {code:"Inactive", colr:"lite"},
]

export default function VaultInfoCard(props) {

  const data = props.data;
  
  return (
    <>
    <div className="card rounded-wd bg-white mb-1">
      <div className="row g-0">
        <div className="p-3" style={{width:"79px", height:"79px"}}>
          <div className="layout-square">
          <img 
            src={data.file} 
            className="rounded img-fluid" alt="...">
          </img>
          </div>
        </div>

        <div className="col">
          <div className="p-0 py-3">
            <p className="fw-bold small  text-muted m-0 p-0 mb-1">{data.name}</p>
            <p className="lead m-0 p-0" style={{lineHeight:"1rem"}}>{data.nmbr}</p>
          </div>
        </div>

        <div className="text-end" style={{width:"fit-content"}}>
          <div className="p-3">
            <span className={`badge rounded-pill p-2 px-3 bg-${stat[data.stat].colr}`}>
              <small>{stat[data.stat].code}</small>
            </span>
            <p className={`small m-0 p-0 mt-1 text-dark ${data.blck ? '' : 'd-none'}`}>
              <small>Blacklisted <i className="bi-circle-fill small"></i></small>
            </p>
          </div>
        </div>

      </div>
    </div>


    </>
  )
}